module.exports = __webpack_public_path__ + "img/GENERAL-BALENO-1.1e7459a3.jpg";